export default {
    'payment.title': 'payment',
};